export default __webpack_public_path__ + "static/media/Aditya.df6d98d1.jpeg";